import ApiRequest from "../util/ApiRequest";
import GlobalData from "../util/GlobalData";

export default class Quiz {
    static byPassPayment = async (body) => {
        return await ApiRequest.set(`/v1/transaction/bypass`, "POST", body);
    }
}
